import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import FindJob from './Pages/FindJob';
import Home from './Pages/Home';
import AboutUs from './Pages/AboutUs';
import CleanerProfile from './Pages/CleanerProfile';
import Admin from './Pages/Admin';
import ProfileForm from './Pages/ProfileForm';
import JobForm from './Pages/JobForm';
import UserDashboard from './Pages/UserDashboard';
import UserProvider from "./Providers/UserProvider";
import './App.css';

function App() {
  return (
    <UserProvider>
      <Router>
        <Switch>
          <Route path='/' exact component={Home} />
          <Route path='/about' component={AboutUs} />
          <Route path='/findjob' component={FindJob} />
          <Route path='/cleanerprofile/:id' component={CleanerProfile} />
          <Route path='/admin' component={Admin} />
          <Route path='/profileform' component={ProfileForm} />
          <Route path='/jobform' component={JobForm} />
          <Route path='/dashboard/' component={UserDashboard} />
        </Switch>
      </Router>
    </UserProvider>
  );
}

export default App;
